export const CONFLUENCE_PAGES = {
  CUSTOM_EMAIL: {
    id: '1268121601',
    wiki: 'pages/1268121601/Modulo+Configurazione+E-mail',
  },
  FAV_CORRISPONDENCE: {
    id: '1268416513',
    wiki: 'pages/1268416513/Modulo+Preferenze+Corrispondenza',
  },
  SERVICES: {
    id: '1268678657',
    wiki: 'pages/1268678657/Modulo+Tipologie+servizi',
  },
  SUPPLIER_SERVICE_ASSOCIATION: {
    id: '1268744193',
    wiki: 'pages/1268744193/Modulo+Associazione+Fornitori-Servizi',
  },
  SUPPLIER_QUALIFICATION: {
    id: '1268875265',
    wiki: 'pages/1268875265/Modulo+Visibilit+Qualifiche+Fornitore',
  },
  SUPPLIER_DOC: {
    id: '1268678723',
    wiki: 'pages/1268678723/Modulo+Visibilit+Documentale+Fornitore',
  },
  RAS: {
    id: '1268416579',
    wiki: 'pages/1268416579/Modulo+Registro+Anagrafe+e+Sicurezza+RAS',
  },
  TEAPOT: {
    id: '1295253505',
    wiki: 'pages/1295253505/App+Teapot',
  },
  DOORBELL: {
    id: '1295646721',
    wiki: 'pages/1295646721/App+Doorbell',
  },
  DOCUMENTI_POSTALI: {
    id: '1346306049',
    wiki: 'pages/1346306049/App+Documenti+Postali',
  },
};
